import React from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { API_URL, API_KEY } from "../API";
import Loader from "./Loader";
import NoData from "./NoData";
import "../style/Wishlist.css";
import '../style/Categories.css';

const fetchWishlist = async () => {
  const token = localStorage.getItem("authToken");
  const response = await axios.get(`${API_URL}/favorite/`, {
    headers: {
      "x-api-key": API_KEY,
      Authorization: `Bearer ${token}`,
      "accept-language": "ar",
    },
  });
  return response.data.data.favorites.favorites;
};

const WishlistPage = () => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading, error } = useQuery({
    queryKey: ["wishlist"],
    queryFn: fetchWishlist,
    staleTime: 1000 * 60 * 5,
  });

  if (isLoading) return <Loader />;
  if (error) {
    enqueueSnackbar("❌ فشل في تحميل المفضلة", { variant: "error" });
    return <div className="error">❌ فشل في تحميل المفضلة</div>;
  }
  if (!Array.isArray(data) || data.length === 0) {
    return <NoData />;
  }

  return (
    <div className="home-cat">
      {data.map((item) => {
        const product = item.product;
        const name = product.translations?.[0]?.name || "منتج بدون اسم";
        const imageSrc = product.image?.startsWith("http")
          ? product.image
          : "/images/ahmad hasoun 2 1.png";

        return (
          <div key={product.id} className="fav-card">
            <div className="head22">
              <button>
                <img src="/images/heart1.svg" alt="favorite" />
              </button>
            </div>
            <div className="middel">
              <img
                src={imageSrc}
                alt={name}
                onError={(e) => (e.target.src = "/images/placeholder.png")}
              />
            </div>
            <div className="buttom">
              <h3>{product.price} KD</h3>
              <p>{name}</p>
              <p>Brand Name</p>
              <p>Company Name</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WishlistPage;
